import { Descriptions, Divider, Drawer, Dropdown } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import svg85 from "../../../../assets/svg/svg85.svg";
import svg79 from "../../../../assets/svg/svg79.svg";
import svg86 from "../../../../assets/svg/svg86.svg";
import svg82 from "../../../../assets/svg/svg82.svg";
import svg80 from "../../../../assets/svg/svg80.svg";
import svg87 from "../../../../assets/svg/svg87.svg";
import svg88 from "../../../../assets/svg/svg88.svg";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../components/ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import {
  formatPathJpa,
  formatText,
  previewPaperApplicant,
} from "../../../../utils";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import InterviewResult from "../candidate/modal/InterviewResult";
import DocumentTable from "../../../public-careers/view/application/documents-applicants/DocumentTable";

function ProfileView({ onClose, openDrawer, prodd, action, handleFetch }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);
  const { open, handleCancel, handleOpen } = useModalToggle();
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const handleOpenAction = async (item) => {
    await setSelectedStatus(item);
    await setContent(
      `Are you sure you want to ${formatText(item)} ${prodd?.japFirstName} ${
        prodd?.japLastName
      }`
    );
    await handleOpen();
  };
  const handleCloseAction = () => {
    handleCancel();
  };

  const [content, setContent] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const handleAction = async () => {
    const res = await dispatch(
      save({
        url: "api/v1/applications/create",
        japProgressStatus: selectedStatus.toUpperCase(),
        japId: prodd?.japId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleCancel();
      await onClose();
      await handleFetch();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const [openMarks, setOpenMarks] = useState(false);
  const handleOpenMarks = async (item) => {
    await setSelectedStatus(item);
    await setOpenMarks(true);
  };
  const handleCloseMarks = async () => {
    await setOpenMarks(false);
  };

  const items1 = [
    {
      key: "1",
      label: "First Name",
      children: prodd?.japFirstName ?? "N/A",
    },

    {
      key: "2",
      label: "Last Name",
      children: prodd?.japLastName ?? "N/A",
    },
    {
      key: "3",
      label: "Email",
      children: prodd?.japEmail ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: prodd?.japPhone ?? "N/A",
    },
    {
      key: "8",
      label: "Address",
      children: prodd?.japAddress ?? "N/A",
    },
    {
      key: "8",
      label: "Gender",
      children: prodd?.japGender ?? "N/A",
    },
    {
      key: "9",
      label: "Nationality",
      children: prodd?.japNationality ?? "N/A",
    },
    {
      key: "10",
      label: "Are you PLWD?",
      children: prodd?.japIsPLWD ? "yes" : "No",
    },
    {
      key: "6",
      label: "Date of Birth",
      children: (
        <div>
          {prodd?.japDob ? moment(prodd?.japDob)?.format("DD-MM-YYYY") : "--"}
        </div>
      ),
    },
  ];
  const items2 = [
    {
      key: "5",
      label: "Are You available Immediately?",
      children: prodd?.japIsAvailable ? "yes" : "No",
    },
    {
      key: "1",
      label: "Notice Period (Weeks)",
      children: prodd?.japNoticePeriod ?? "N/A",
    },
    {
      key: "2",
      label: "Why are you interested in this position?",
      children: prodd?.japInterestDesc ?? "N/A",
    },
    {
      key: "3",
      label: "Interview Score (%)",
      children: prodd?.japInterviewScore ?? "N/A",
    },
    {
      key: "4",
      label: "Interview Remarks",
      children: prodd?.japInterviewRemarks ?? "N/A",
    },
  ];

  const iconsMap = {
    Shortlist: svg80,
    Schedule_Interview: svg86,
    Offer: svg82,
    Hire: svg82,
    Drop: svg82,
    "Interview Results": svg80,
  };

  const labelMap = {
    Shortlist: "Shortlist",
    Schedule_Interview: "Schedule Interview",
    Offer: "Offer",
    Hire: "Hire",
    Drop: "Drop",
    "Interview Results": "Interview Results",
  };

  const desiredOrder = [
    "Shortlist",
    "Interview Results",
    "Offer",
    "Hire",
    "Drop",
  ];

  const buildMenuItems = (steps) => {
    const sortedSteps = [...(steps || [])].sort(
      (a, b) => desiredOrder?.indexOf(a) - desiredOrder?.indexOf(b)
    );

    return sortedSteps?.flatMap((step, index) => {
      const stepKey = index + 1;

      const onClickHandler =
        step === "Interview Results"
          ? () => handleOpenMarks(step)
          : () => handleOpenAction(step);
      return [
        {
          key: String(stepKey),
          label: (
            <Link
              className="flex gap-x-[.75rem] items-center py-[.5rem]"
              onClick={onClickHandler}
            >
              <img src={iconsMap[step]} alt={step} className="w-4 h-4" />
              <span className="whitespace-nowrap">{labelMap[step]}</span>
            </Link>
          ),
        },
        index < sortedSteps?.length - 1 && {
          key: `divider-${stepKey}`,
          type: "divider",
        },
      ]?.filter(Boolean);
    });
  };
  const settingItems = buildMenuItems(activeObjJob?.jobRecruitmentProcess);
  console.log("prodd", prodd);
  return (
    <Drawer
      width={850}
      title="Candidate Info"
      open={openDrawer}
      onClose={onClose}
      closable={true}
      closeIcon={null}
      extra={
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            fontSize: "1.25rem",
            color: "#FFF",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      }
    >
      <div className="flex items-center justify-between">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={onClose}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>

        {action && (
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button
              className="max-w-[7.0625rem]  py-0 px-[.75rem] gap-[.5rem] rounded-[1.625rem] border border-[#DAA520] bg-[#F9F9F9] flex items-center min-h-[2.5rem]"
              type="button"
            >
              Actions
              <img src={svg79} alt="svg79" />
            </button>
          </Dropdown>
        )}
      </div>

      <div className="w-full mt-[2.5rem]">
        <Descriptions
          title="Personal Information"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <div className="py-[2.5rem] flex items-center justify-between">
          <div className="flex flex-col">
            <div className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans">
              Cv
            </div>
            {prodd?.japCvFile ? (
              <div className="flex items-center justify-between mt-[1rem] ">
                <div
                  className="flex items-center gap-[.75rem] underline cursor-pointer"
                  onClick={() => previewPaperApplicant(prodd?.japCvFile)}
                >
                  <img
                    src={svg87}
                    alt="svg87"
                    className="w-[1.375rem] h-[1.375rem]"
                  />
                  {formatPathJpa(prodd?.japCvFile)}
                </div>
                <img
                  className="lg:ml-[3rem] ml-[1rem] cursor-pointer"
                  src={svg88}
                  alt="svg88"
                  onClick={() => previewPaperApplicant(prodd?.japCvFile)}
                />
              </div>
            ) : (
              <span className="my-2">No File</span>
            )}
          </div>

          <div className="flex flex-col">
            <div className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans">
              Cover Letter
            </div>
            {prodd?.japCoverLetterFile ? (
              <div className="flex items-center justify-between mt-[1rem] w-full">
                <div
                  className="flex items-center gap-[.75rem] underline cursor-pointer"
                  onClick={() =>
                    previewPaperApplicant(prodd?.japCoverLetterFile)
                  }
                >
                  <img
                    src={svg87}
                    alt="svg87"
                    className="w-[1.375rem] h-[1.375rem]"
                  />
                  {formatPathJpa(prodd?.japCoverLetterFile)}
                </div>

                <img
                  className="lg:ml-[3rem] ml-[1rem] cursor-pointer"
                  src={svg88}
                  alt="svg88"
                  onClick={() =>
                    previewPaperApplicant(prodd?.japCoverLetterFile)
                  }
                />
              </div>
            ) : (
              <span className="my-2">No File</span>
            )}
          </div>
        </div>
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        {prodd?.docs?.length > 0 && <DocumentTable review={true} dataView={prodd?.docs} />}
      </div>

      <ConfirmModal
        open={open}
        handleCancel={handleCloseAction}
        handleSubmit={handleAction}
        loading={saving}
        content={content}
        type="info"
        btnTitle="Confirm"
      />

      <InterviewResult
        open={openMarks}
        handleCancel={handleCloseMarks}
        handleFetch={handleFetch}
        title={`Interview Results for ${prodd?.japFirstName} ${prodd?.japLastName}`}
        prodd={prodd}
        onClose={onClose}
      />
    </Drawer>
  );
}

export default ProfileView;
